import { connect } from 'react-redux';
import { logWidgetSystem } from '../worker/actions/bi';
import React from 'react';
import { Direction } from '../containers/direction';
import HomeLayout from './layouts/home/home';
import { WindowSize } from '../containers/window-size';
import { MobileOverlayModal } from '../mobile-overlay/MobileOverlayModal';
import { MobileOverlayProvider } from '../mobile-overlay/MobileOverlayProvider';
import { useConfigBridge } from '../utils/useConfigBridge';
import { reinitializeWidget } from './initial-data-mobile';

function ConfigBridge() {
  useConfigBridge(reinitializeWidget);
  return null;
}

const mapStateToProps = null;
const mapDispatchToProps = { logWidgetSystem };

export const Component = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class Component extends React.Component {
    componentDidMount() {
      this.props.logWidgetSystem('mobile.app.initialized');
    }

    render() {
      return (
        <MobileOverlayProvider>
          <ConfigBridge />
          <WindowSize>
            <Direction>
              <HomeLayout />
              <MobileOverlayModal />
            </Direction>
          </WindowSize>
        </MobileOverlayProvider>
      );
    }
  },
);
